import React from 'react'
import Link from 'gatsby-link'

import './IconLink.css'

const IconLink = (props) => (
  <div className="icon-link">
    <img className="icon" src={props.icon} alt="" />
    <Link className="button button-tertiary" to={props.link}>
      {props.title}
    </Link>
  </div>
)

export default IconLink
